import { HISTORY_PUSH } from '../action-types';

// @ts-expect-error - Automatic, Please fix when editing this file
const push = (location) => (dispatch) => dispatch({ location, type: HISTORY_PUSH });

export default { push };
